import script from "./MyForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyForm.vue?vue&type=script&lang=ts&setup=true"

import "./MyForm.vue?vue&type=style&index=0&id=fc7f41be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc7f41be"]])

export default __exports__